import React from 'react';
import styled, { keyframes } from 'styled-components';

import { darkColors } from 'src/setup/theme/colors';

const blink = keyframes`
  0% { opacity: 0.2; }
  20% { opacity: 1; }
  100% { opacity: 0.2; }
`;

const DotsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
`;

const Dot = styled.span<{ delay: string }>`
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${darkColors.primary};
    animation: ${blink} 1.4s infinite ease-in-out both;
    animation-delay: ${({ delay }) => delay};
`;

export const LoadingDots = () => (
    <DotsContainer>
        <Dot delay="0s" />
        <Dot delay="0.2s" />
        <Dot delay="0.4s" />
    </DotsContainer>
);
